module.exports = __webpack_public_path__ + "9ff8ce367bcddeffb21e32b81e5972bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/lvy_g.png
// module id = 251
// module chunks = 3